import { render, staticRenderFns } from "./Tos.vue?vue&type=template&id=3584a036&scoped=true"
import script from "./Tos.vue?vue&type=script&setup=true&lang=js"
export * from "./Tos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Tos.vue?vue&type=style&index=0&id=3584a036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584a036",
  null
  
)

export default component.exports